"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseData = exports.isDate = exports.parseDate = void 0;

var constants_1 = require("./constants");

exports.parseDate = function (date) {
  var isYear = date.toString().length === 4;

  if (isYear) {
    return date;
  }

  var dateParser = new Date(date);
  date = "".concat(dateParser.getDate(), " ").concat(constants_1.MONTHS[dateParser.getMonth()]);
  return date;
};

exports.isDate = function (date) {
  return typeof date === 'number' || !isNaN(Date.parse(date));
};

exports.parseData = function (data) {
  return data ? data.map(function (d) {
    if (exports.isDate(d.x)) {
      d.x = exports.parseDate(d.x);
    }

    return d;
  }) : [];
};